export default __webpack_public_path__ + "media/color/dat-df05d159.svg";